"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'ActivityQrcodeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    // 二维码列表：[{ label: '点餐端', url: '活动页链接' }, { label: '社区端', url: '活动页链接' }]
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    // 使用第三方二维码服务将活动页链接生成二维码图片
    toQrImage: function toQrImage(url) {
      var size = 500;
      return "https://api.qrserver.com/v1/create-qr-code/?size=".concat(size, "x").concat(size, "&data=").concat(encodeURIComponent(url));
    }
  }
};